<template>
  <div class="ai-init-uninitialized">
    <div class="ai-init-uninitialized__header">
      <div class="ai-init-uninitialized__logo-wrap">
        <img alt="AI 初始化" class="ai-init-uninitialized__logo" :src="aiLogoEmpty" />
      </div>
      <div class="ai-init-uninitialized__title-row">
        <div class="ai-init-uninitialized__title">
          Hi，请输入完整企业名称，通过「联网查询」自动帮您智能搭建初始化内容
        </div>
        <i class="ai-init-uninitialized__title-icon icon-sparkling-2-fill t-iconfont"></i>
      </div>
    </div>
    <div class="ai-init-uninitialized__input">
      <el-input
        v-model="companyName"
        class="ai-init-uninitialized__input-inner"
        placeholder="请输入完整企业名称"
      />
    </div>
    <div class="ai-init-uninitialized__action" @click="handleGenerate">
      <span>AI 智能生成</span>
      <i class="icon-arrow-right-line t-iconfont"></i>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import aiLogoEmpty from '@/assets/ai-logo-empty.png'
import { ElMessage } from 'element-plus'
import utils from '@/utils'

const emit = defineEmits(['generate'])
const userInfo = utils.xbbLocalStorageGet('userInfo') || {}
const companyName = ref(userInfo.companyName || '')

const handleGenerate = () => {
  if (!companyName.value.trim()) {
    ElMessage.warning('请输入完整企业名称')
    return
  }
  emit('generate', companyName.value)
}
</script>

<style lang="scss" scoped>
.ai-init-uninitialized {
  width: 100%;
  height: 100%;
  flex: 1;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  box-sizing: border-box;
  border: 1px solid #e5e6eb;
}

.ai-init-uninitialized__header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ai-init-uninitialized__logo-wrap {
  width: 176px;
  height: 118px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-init-uninitialized__logo {
  width: 176px;
  height: 118px;
  display: block;
}

.ai-init-uninitialized__title-row {
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.ai-init-uninitialized__title {
  font-family: 'PingFang SC', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #323233;
}

.ai-init-uninitialized__title-icon {
  margin-left: 8px;
  font-size: 16px;
  line-height: 16px;
  background: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.ai-init-uninitialized__input {
  width: 280px;
  margin-top: 24px;
}

.ai-init-uninitialized__input-inner {
  width: 100%;
}

.ai-init-uninitialized__input-inner :deep(.el-input__wrapper) {
  min-height: 32px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
  border: 1px solid #dcdee0;
}

.ai-init-uninitialized__input-inner :deep(.el-input__wrapper.is-focus) {
  box-shadow: none;
  border-color: #7a52f4;
}

.ai-init-uninitialized__input-inner :deep(.el-input__inner) {
  height: 20px;
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #323233;
}

.ai-init-uninitialized__input-inner :deep(.el-input__inner::placeholder) {
  color: #c0c4cc;
}

.ai-init-uninitialized__action {
  cursor: pointer;
  width: 122px;
  height: 34px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(124, 58, 237, 0.15);
  border-radius: 12px;
  box-sizing: border-box;
  background: linear-gradient(285deg, #eef2ff 1%, #f5f3ff 100%);
  font-family: 'PingFang SC', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #4f46e5;
}

.ai-init-uninitialized__action span {
  background: linear-gradient(285deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.ai-init-uninitialized__action .t-iconfont {
  margin-left: 8px;
  font-size: 14px;
  line-height: 14px;
  background: linear-gradient(285deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
</style>
